import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { logoutUser } from "../store/modules/login/index";
import { breakpoints } from "../Media";

const Button = styled.button`
  height: 2.5em;
  width: 8em;
  color: white;
  font-weight: 600;
  background-color: gray;
  margin-right: 1em;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  :focus {
    outline: none;
  }
  @media (max-width: ${breakpoints.mobileMin}) {
    margin-right: 0.1em;
    width: 7em;
  }
`;

class SignOut extends Component {
  state = {};

  handleLogOut = (e) => {
    e.preventDefault();
    const { logoutUser } = this.props;
    logoutUser();
  };
  render() {
    return <Button onClick={this.handleLogOut}>Log Out</Button>;
  }
}

export const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser()),
});

export default connect(null, mapDispatchToProps)(SignOut);
